import type { AppNotificationDto } from '@/types/dto/notification.dto';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function isNotificationUnread(notification: AppNotificationDto) {
  return !notification.readAt;
}

export function getNotificationLink(notification: AppNotificationDto) {
  const link = notification.metadata?.link;

  if (typeof link !== 'string' || !link.startsWith('/') || link.startsWith('//')) {
    return null;
  }

  return link;
}

export function formatNotificationDate(value: string) {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return 'Agora';
  }

  return formatDistanceToNow(date, {
    addSuffix: true,
    locale: ptBR,
  });
}
